import { addClass, removeClass } from './dom'
import textImage from './icon/wx-share-mask-bg.png'

const scale = (() => {
  const meta = <Element>document.querySelector('meta[name="viewport"]')
  const scalc = (<string>meta.getAttribute('content')).match(/initial-scale=([\d.]+)/)
  if (scalc) {
    return parseFloat(scalc[1])
  } else {
    return 1
  }
})()

const rate = parseInt(`${1 / scale}`, 10)

const ID = '__wx-share-guide__'

const styleTpl = `
  @-webkit-keyframes fadeIn {
    0% {
        opacity: 0
    }

    to {
        opacity: 1
    }
  }

  @keyframes fadeIn {
    0% {
        opacity: 0
    }

    to {
        opacity: 1
    }
  }

  @-webkit-keyframes fadeOut {
    0% {
        opacity: 1
    }

    to {
        opacity: 0
    }
  }

  @keyframes fadeOut {
    0% {
        opacity: 1
    }

    to {
        opacity: 0
    }
  }

  #${ID} {
    -webkit-animation-duration: 1s;
    animation-duration: 1s;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both
  }

  #${ID}.fadeIn {
    -webkit-animation-name: fadeIn;
    animation-name: fadeIn
  }

  #${ID}.fadeOut {
    -webkit-animation-name: fadeOut;
    animation-name: fadeOut
  }
`

const maskStyle = [
  'position: fixed',
  'z-index: 999',
  'top: 0',
  'right: 0',
  'bottom: 0',
  'left: 0',
  'background: rgba(0, 0, 0, 0.7)',
]

const imgStyle = [
  'position: absolute',
  'top: ' + (21 * rate / 40) + 'rem',
  'right: ' + (64 * rate / 40) + 'rem',
  'width: ' + (228 * rate / 40) + 'rem',
  'height: ' + (255 * rate / 40) + 'rem',
]

const textStyle = [
  'width: 100%',
  'text-align: center',
  'color: #fff',
  'font-family: PingFangSC-Regular',
  'font-size: 15px',
  'position: absolute',
  'top: ' + (305 * rate / 40) + 'rem',
]

const maskTpl = `
  <div style="${maskStyle.join(';')}">
    <img src="${textImage}" style="${imgStyle.join(';')}"/>
    <p style="${textStyle.join(';')}">点击这里，将活动分享给好友哦~</p>
  </div>
`

const appendStyle = () => {
  const id = `${ID}-stylesheet`
  let style: HTMLStyleElement = <HTMLStyleElement>document.getElementById(id)
  if (!style) {
    style = document.createElement('style')
    style.id = id
    style.type = 'text/css'
    style.innerHTML = styleTpl

    const head = <HTMLHeadElement>document.querySelector('head')
    head.appendChild(style)
  }
  return style
}

export default () => {
  appendStyle()
  const dom: any = document.createElement('div')
  dom.id = ID
  dom.innerHTML = maskTpl

  const onAnimationEnd = () => {
    removeClass(dom, 'fadeIn')
    removeClass(dom, 'fadeOut')
    if (dom.remove) {
      dom.parentNode.removeChild(dom)
    }
  }

  const click = () => {
    addClass(dom, 'fadeOut')
    dom.remove = true
  }

  dom.remove = false
  dom.addEventListener('click', click, false)
  dom.addEventListener('webkitAnimationEnd', onAnimationEnd, false)
  dom.addEventListener('animationend', onAnimationEnd, false)
  document.body.appendChild(dom)
  addClass(dom, 'fadeIn')

  dom.emitClick = click
  return dom
}
